document.addEventListener('DOMContentLoaded', () => {

  setTimeout(() => {
    const kvMessageItemInners = document.querySelectorAll('.js-kv-message-item-inner');

    kvMessageItemInners.forEach((kvMessageItemInner) => {
      kvMessageItemInner.classList.add('is-active');
    });
  }, 400);

  setTimeout(() => {
    const kvMessages = document.querySelectorAll('.js-kv-message');

    kvMessages.forEach((kvMessage) => {
      kvMessage.classList.add('is-active');
    });
  }, 600);

  setTimeout(() => {
    const kvSlide = document.querySelector('.js-kv-slide');
    const kvSlideItems = document.querySelectorAll('.js-kv-slide-item');
    let delay = 0;

    kvSlideItems.forEach((kvSlideItem) => {
      kvSlideItem.classList.add('is-hidden');
    });

    kvSlide.classList.add('is-show');

    setTimeout(() => {
      kvSlideItems.forEach((kvSlideItem) => {
        kvSlideItem.style.transition = 'opacity 0.8s ease-in-out';
        kvSlideItem.style.transitionDelay = `${delay}s`;
        delay += 0.05;
        kvSlideItem.classList.remove('is-hidden');
      });
    }, 200);
  }, 600);

  setTimeout(() => {
    const kvTitles = document.querySelectorAll('.js-kv-title');
    let delayOpacity = 0;
    let delayColor = 600;

    kvTitles.forEach((kvTitle) => {
      setTimeout(() => {
        kvTitle.classList.add('is-opacity');
      }, delayOpacity);
      delayOpacity += 200;

      setTimeout(() => {
        kvTitle.classList.add('is-color');
      }, delayColor);
      delayColor += 200;
    });
  }, 800);

  setTimeout(() => {
    const kvBanner = document.querySelector('.js-kv-banner');
    kvBanner.classList.add('is-show');
  }, 1200);

  setTimeout(() => {
    const kvTitleMessages = document.querySelectorAll('.js-kv-title-message');

    kvTitleMessages.forEach((kvTitleMessage) => {
      kvTitleMessage.classList.add('is-show');
    });
  }, 1600);
});
